import { useToast } from '@/contexts/ToastContext';

/**
 * Hook para limpiar todos los diálogos
 * Útil para limpiar diálogos cuando el usuario hace logout
 */
export const useDialogCleanup = () => {
  const { clearAllDialogs } = useToast();

  return { clearAllDialogs };
};
